<script lang="ts">
  import { useWallet } from '@do/svelte-web3-manager';
  import { getBalanceFromEth } from '@shared/lib';
  import { Icon } from '@shared/ui/icon';
  import { walletSidebarModel } from '@widgets/wallet-sidebar';
  import { Link } from '@shared/ui/link';
  import ConnectedWallet from './connected-wallet.svelte';

  const wallet = useWallet();

  $: balance = getBalanceFromEth($wallet?.balance);
</script>

<section>
  <ConnectedWallet />

  <p class="my-4 text-base font-medium">Wallet Balance</p>

  <div
    class="shadow-wallet-sidebar dark:border-default-50/10 border-default-250 overflow-hidden rounded-lg border border-transparent dark:shadow-transparent"
  >
    <div class="dark:bg-alt-dark flex items-center gap-2 px-4 py-5">
      <Icon name="usdc" width="{20}" height="{20}" />

      <div class="flex items-center gap-1">
        <p class="text-[20px] font-medium leading-[24px]">{balance.usdc}</p>

        <p class="text-[20px] font-medium leading-[24px]">USDC</p>
      </div>
    </div>

    <div class="bg-default-250 dark:bg-default-50/10 h-[1px]"></div>

    <div class="dark:bg-alt-dark flex items-center gap-2 px-4 py-5">
      <Icon name="eth" width="{20}" height="{20}" />

      <div class="flex items-center gap-1">
        <p class="text-[20px] font-medium leading-[24px]">{balance.eth}</p>

        <p class="text-[20px] font-medium leading-[24px]">ETH</p>
      </div>
    </div>
  </div>

  {#if balance.usd === 0}
    <p class="text-default-600 dark:text-dark-800 my-4">
      There are no funds in your wallet. Please top up your balance in USDC.
      <br />
      Instructions to fund your wallet are in our
      <Link
        props="{{
          class: 'underline dark:text-dark-800',
          href: 'faq',
        }}"
        on:click="{() => walletSidebarModel.walletSidebarActivity.close()}"
      >
        FAQ.
      </Link>
    </p>
  {/if}
</section>
